exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".big[data-v-371d3daa]{font-size:1em}@media (min-width:992px){.big[data-v-371d3daa]{font-size:2em}}.extra-big[data-v-371d3daa]{font-size:4.5em}.frame[data-v-371d3daa]{padding:15px;max-height:800px}.bordered-container[data-v-371d3daa]{border:1px solid #fff;padding:15px;height:770px;color:#fff}.bordered-container h1[data-v-371d3daa],.bordered-container h2[data-v-371d3daa]{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-371d3daa","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/vue/components/work/Work.vue
// module id = vHUJ
// module chunks = 0